module.exports = __webpack_public_path__ + "static/bhaal-mtg_clb-c1365b141c3edecc9b242e2c5ed8d78a.jpg";